import React, { useState, useContext } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import Card from '../components/common/Card';
// import Hyperlink from './../components/common/Hyperlink';
import Label from './../components/common/Label';
import FormInput from './../components/FormInput';
import FormSuccess from './../components/FormSuccess';
import FormError from './../components/FormError';
import GradientBar from './../components/common/GradientBar';
import { AuthContext } from '../context/AuthContext';
import { FetchContext } from '../context/FetchContext';
// import { Redirect, Link } from 'react-router-dom';
import GradientButton from '../components/common/GradientButton';
import logo from './../images/logo.png';

const LoginSchema = Yup.object().shape({
  email: Yup.string().required('Email is required'),
});

export const ForgotPassword = () => {
  const authContext = useContext(AuthContext);
  const fetchContext = useContext(FetchContext);
  const [loginSuccess, setLoginSuccess] = useState();
  const [loginError, setLoginError] = useState();

  const submitCredentials = async credentials => {
    try {
      console.log(`✈  credentials: ${credentials}`);
      const { data } = await fetchContext.publicAxios.post(
        `forgot-password`,
        credentials
      );

      authContext.setAuthState(data);
      setLoginSuccess(data.message);
      setLoginError(null);
    } catch (error) {
      const { data } = error.response;
      setLoginError(data.message);
      setLoginSuccess(null);
    }
  };

  return (
    <>
      <section className="w-full sm:w-1/2 h-screen m-auto p-8 sm:pt-10">
        <GradientBar />
        <Card>
          <div className="flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full">
              <div>
                <div className="w-32 m-auto mb-6">
                  <img src={logo} alt="Logo" />
                </div>
                <h2 className="mb-2 text-center text-3xl leading-9 font-extrabold text-gray-900">
                  Reset Password
                </h2>
              </div>

              <Formik
                initialValues={{
                  email: '',
                  redirectUrl: `http://localhost:3001/api/forgot-password/`,
                }}
                onSubmit={values => submitCredentials(values)}
                validationSchema={LoginSchema}
              >
                {() => (
                  <Form className="mt-8">
                    {loginSuccess && <FormSuccess text={loginSuccess} />}
                    {loginError && <FormError text={loginError} />}
                    <div>
                      <div className="mb-2">
                        <div className="mb-1">
                          <Label text="Email" />
                        </div>
                        <FormInput
                          name="email"
                          type="text"
                          placeholder="Enter your email address"
                        />
                      </div>
                    </div>

                    <div className="mt-6">
                      <GradientButton type="submit" text="Submit" />
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </Card>
      </section>
    </>
  );
};

// export default Login;
